
export enum ConfigurationActions {
  SET_IS_DOWNLOAD_BUTTTON_DISABLED = 'SET_IS_DOWNLOAD_BUTTTON_DISABLED',
}

export interface SoftwareConfigurationState {
  isDownloadButtonDisabled: boolean;
}

interface SetSoftwareConfiguration {
  type: typeof ConfigurationActions.SET_IS_DOWNLOAD_BUTTTON_DISABLED;
  payload: boolean;
}

export type ConfigurationActionTypes = SetSoftwareConfiguration;
